/**
 * Styled Components - Created by eduardoquintero on 07/05/19.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import Mentions from 'antd/lib/mention'
import Switch from 'antd/lib/switch'
import Collapse from 'antd/lib/collapse'
import {
  BLUE,
  GRAY_DARK,
  RED,
  GRAY_LIGHTEST,
  GRAY_HEADER,
  ORANGE_SELECTED,
  ORANGE,
  GREEN,
  GREEN_SELECTED,
  GRAY_LIGHT,
  GRAY,
  WHITE,
  WHITE_SMOKE,
  GRAY_SOFT,
  GRAY_STRONG,
  BLUE_SOFT,
  RED_TRANSPARENT,
  FACEBOOKBLUE,
  DARKER_GRAY,
  GREEN_TRANSPARENT,
  BLUE_BRIGHT,
  COLOR_AM_REVIEW
} from '../../../theme/colors'
import { AVENIR_MEDIUM } from '../../../theme/fonts'
import Icon from 'antd/lib/icon'
import Spin from 'antd/lib/spin'
import Upload from 'antd/lib/upload'
import TextArea from 'antd/lib/input/TextArea'

const { Nav } = Mentions
const { Panel } = Collapse

interface ColorProps {
  color?: string
}

interface RowProps {
  margin?: string
  borderBottom?: string
  paddingBottom?: string
  height?: string
  secondary?: boolean
  isAdmin?: boolean
  centered?: boolean
  selected?: boolean
  fromSystem?: boolean
  colorStatus?: string
  colorTitle?: string
  codeColor?: string
}

export const SubLabel = styled.div`
  font-size: 11px;
  color: ${GRAY_SOFT};
  font-style: italic;
  display: inline-block;
  margin-left: 6px;
  font-weight: normal;
`

export const ScreenSubTitle = styled.div`
  color: #5f6062;
  font-family: 'Avenir Next';
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  font-weight: normal;
`
export const BlueButton = styled(Button)`
  padding: 0 34px;
  color: white;
  background-color: ${BLUE};
  margin-right: 20px;
`

export const DesignChat = styled.div`
  height: 450px;
  margin-top: 8px;
  position: relative;
  display: flex;
  flex-flow: column;
`

export const NavStyled = styled(Nav)``

export const MentionStyled = styled(Mentions)`
  border-radius: 0 !important;
  border-bottom: 0px;
  outline: none;
  box-shadow: none !important;
  resize: none;
  .ant-mention-editor {
    border-radius: 0;
    border: 1px solid ${GRAY_LIGHT} !important;
    border-bottom: none !important;
    padding: 8px 0;
    padding-top: 4px;
    box-shadow: none !important;
    .ant-mention-wrapper .ant-mention-editor {
      line-height: 0.5 !important;
    }
    .public-DraftStyleDefault-block {
      margin: 2px 0 !important;
      & > span:not([data-offset-key]) {
        color: ${BLUE};
      }
    }
    &:hover {
      border: 1px solid ${GRAY_LIGHT};
      border-bottom: 0px;
      cursor: text;
    }
    &:focus {
      border: 1px solid ${GRAY_LIGHT};
      border-bottom: 0px;
      outline: none;
      box-shadow: none;
      resize: none;
    }
  }
`

export const MentionStyledRead = styled.div`
  cursor: text;
  display: inline-block;
  text-align: left;
  word-break: break-word;
  white-space: break-spaces;
  a, span {
    color: ${BLUE};
  }
`

export const TextAreaStyled = styled(TextArea)`
  border-radius: 0;
  border-bottom: 0px;
  outline: none;
  box-shadow: none;
  resize: none;
  padding-right: 128px;
  &:hover {
    border: 1px solid ${GRAY_LIGHT};
    border-bottom: 0px;
  }
  &:focus {
    border: 1px solid ${GRAY_LIGHT};
    border-bottom: 0px;
    outline: none;
    box-shadow: none;
    resize: none;
  }
`

export const EditButton = styled.div`
  position: absolute;
  margin-left: 6px;
  margin-top: 6px;
  background: ${WHITE};
  padding: 4px 18px;
  color: ${BLUE};
  border: 1px solid ${BLUE};
  border-radius: 2px;
  z-index: 2;
  transition: all .25s;
  &:hover {
    color: ${WHITE};
    background: ${BLUE};
    cursor: pointer;
  }
`

export const Initials = styled.div`
  width: 24px;
  font-size: 12px;
  height: 24px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHT};
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-left: ${({ isAdmin }: RowProps) => isAdmin ? '12px' : '0'};
`

export const UserName = styled.div`
  margin-left: 12px;
  font-weight: bold;
`

export const DateMessage = styled.div`
  margin-left: 10px;
  color: ${GRAY_SOFT};
`

export const MessageText = styled.div`
  flex: 1;
  white-space: pre-line;
  display: flex;
  flex-flow: column;
`

export const MessageDiv = styled.div`
  flex: 1;
`

export const ImageMessage = styled.img`
  max-width: 100%;
  max-height: 278px;
  margin-top: 10px;
  margin-bottom: 8px;
`

export const MessageType = styled.div`
  text-transform: uppercase;
  color: ${({ colorTitle }: RowProps) => colorTitle || GREEN};
  background: ${({ colorStatus }: RowProps) => colorStatus || GREEN_SELECTED};
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  justify-content: center;
  border-radius: 2px;
  align-items: center;
  margin-left: 6px;
  word-break: keep-all;
  max-height: 22px;
  transition: all .25s;
  ${({ secondary }: RowProps) => secondary ? `
    box-shadow: 1px 1px 2px 0px lightgrey;
    &:hover {
      cursor: pointer;
      box-shadow: 1px 1px 2px 0px #b1b1b1;
    }
  ` : ''}
  @media (max-width: 698px) {
    font-size: 11px;
  }
`

export const CodeDiv = styled.div``

export const PaidLabel = styled.div`
  background: ${({ secondary }: RowProps) => secondary ? '#9dd95b' : '#55c2eb'};
  color: ${WHITE};
  margin-top: 6px;
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  justify-content: center;
  border-radius: 2px;
  align-items: center;
  margin-left: 6px;
  word-break: keep-all;
  max-height: 22px;
`

export const RightDiv = styled.div`
  display: flex;
  flex-flow: column;
`

export const EditTask = styled.div`
  text-transform: uppercase;
  color: ${DARKER_GRAY};
  border: 1px solid ${GRAY_SOFT};
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  border-radius: 2px;
  align-items: center;
  margin-left: 6px;
  justify-content: center;
  margin-top: 6px;
  justify-content: center;
  word-break: keep-all;
  max-height: 22px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${RED};
    border: 1px solid ${RED};
  }
`

export const DeleteTask = styled.div`
  text-transform: uppercase;
  color: #b3b3b3;
  border: 1px solid ${GRAY};
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  border-radius: 2px;
  align-items: center;
  margin-left: 6px;
  justify-content: center;
  margin-top: 6px;
  justify-content: center;
  word-break: keep-all;
  max-height: 22px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${RED};
    border: 1px solid ${RED};
  }
`

export const StartTask = styled.div`
  text-transform: uppercase;
  color: ${GREEN_TRANSPARENT};
  border: 1px solid ${GREEN_TRANSPARENT};
  box-shadow: 1px 2px 3px -2px #bfbfbf;
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  border-radius: 2px;
  align-items: center;
  margin-left: 6px;
  justify-content: center;
  margin-top: 6px;
  justify-content: center;
  word-break: keep-all;
  max-height: 22px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${RED};
    border: 1px solid ${RED};
  }
`

export const ButtonIcon = styled(Icon)`
  margin-right: 4px;
  margin-left: -3px;
`

export const PauseTask = styled.div`
  text-transform: uppercase;
  color: #c4821a99;
  border: 1px solid #c4821a99;
  box-shadow: 1px 2px 3px -2px #bfbfbf;
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  border-radius: 2px;
  align-items: center;
  margin-left: 6px;
  justify-content: center;
  margin-top: 6px;
  justify-content: center;
  word-break: keep-all;
  max-height: 22px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${RED};
    border: 1px solid ${RED};
  }
`

export const StartedLabel = styled.div`
  text-transform: uppercase;
  color: ${GREEN_TRANSPARENT};
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  border-radius: 2px;
  align-items: center;
  margin-left: 6px;
  justify-content: center;
  margin-top: 6px;
  justify-content: center;
  word-break: keep-all;
  max-height: 22px;
  transition: all .25s;
`

export const CircleNotify = styled.div`
  width: 22px;
  font-size: 10px;
  color: white;
  font-weight: bold;
  height: 22px;
  background: ${RED_TRANSPARENT};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`

export const NotificationsDiv = styled.div`
  position: absolute;
  right: 38px;
  display: flex;
  justify-content: space-between;
`

export const SpinStyled = styled(Spin)`
  display: flex;
  align-items: center;
  margin-right: 12px;
`

export const MarkRead = styled.div`
  color: ${RED};
  font-weight: normal;
  font-size: 12px;
  margin-right: 12px;
  border-radius: 2px;
  transition: all .25s;
  padding: 0 8px;
  border: 1px solid ${WHITE};
  &:hover {
    cursor: pointer;
    border: 1px solid ${RED};
  }
  &:active {
    background: ${RED};
    color: ${WHITE};
  }
`

export const ButtonContainer = styled.div`
  padding: 5px 2px;
  text-align: left;
  background: ${WHITE};
  border: 1px solid ${GRAY_LIGHT};
  border-top: 0;
`

export const MessageActions = styled.div`
  padding: 5px 2px;
  text-align: left;
  background: ${WHITE};
  border: 1px solid ${GRAY_LIGHT};
  border-top: 0;
  display: flex;
  align-items: flex-end;
`

export const ChatMessages = styled.div`
  margin-top: 18px;
  flex: 1;
  overflow-y: scroll;
`

export const StyledUpload = styled(Upload)`
  margin-left: 12px;
  .ant-upload-select-picture-card {
    border: 1px solid ${RED};
    width: 105px;
    height: 26px;
    background: ${WHITE};
    border-radius: 2px;
    margin-bottom: 0;
    transition: all .25s;
    @media (max-width: 767px) {
      width: 100%;
    }
    &:hover {
      background: ${RED};
      cursor: pointer;
      span > div {
        color: ${WHITE} !important;
      }
    }
    span {
      padding: 0 6px !important;
    }
  }

`

export const UploadButton = styled.div`
  color: ${RED};
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: center;
  transition: all .25s;
  width: 100%;
  .ant-spin {
    padding-top: 3px;
  }
`

export const StyledIcon = styled(Icon)`
  margin-right: 16px;
`

export const FileLabelAdmin = styled.div`
  display: flex;
  transition: all .25s;
  margin-left: 12px;
`

export const IncomingMessage = styled.div`
  margin-top: 20px;
  margin-bottom: 37px;
  text-align: ${({ isAdmin }: RowProps) => isAdmin ? 'right' : 'left'};
`

export const DeletedTaskLabel = styled.div`
  margin: 0 auto;
  width: fit-content;
  font-size: 11px;
  margin-top: 0px;
  margin-bottom: -20px;
  background: #e617378a;
  color: ${WHITE};
  padding: 2px 12px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-left: calc(80% - 83px);
`

export const MessageHeader = styled.div`
  display: flex;
  margin-bottom: 8px;
  align-items: center;
  flex-flow: ${({ isAdmin }: RowProps) => isAdmin ? 'row-reverse' : 'row'};
`

export const MessageBody = styled.div`
  display: inline-flex;
  width: 100%;
  word-break: break-word;
  color: ${({ secondary }: RowProps) => secondary ? GRAY_SOFT : 'unset'};
  font-style: ${({ secondary }: RowProps) => secondary ? 'italic' : 'normal'};
  flex-flow: ${({ isAdmin }: RowProps) => isAdmin ? 'row-reverse' : 'row'};
  justify-content: space-between;
`

export const StarIcon = styled(Icon)`
  position: relative;
  right: 7px;
  bottom: 17px;
  color: ${RED};
  font-size: 16px;
`

export const MessageBox = styled.div`
  background: ${WHITE};
  padding: 8px 12px;
  box-shadow: 0px 2px 7px 0px ${GRAY_LIGHT};
  display: inline-flex;
  flex-flow: column;
  border-radius: 3px;
  width: ${({ isAdmin }: RowProps) => isAdmin ? 'auto' : '80%'};
  justify-content: space-between;
  @media (max-width: 698px) {
    font-size: 12px;
  }
`

export const ScheduleLabel = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const EditIcon = styled(Icon)`
  margin-left: 8px;
  font-size: 14px;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${RED};
  }
`

export const ScheduleDiv = styled.div`
  display: flex;
  margin-top: 8px;
  font-size: 12px;
  align-items: center;
  @media (max-width: 698px) {
    font-size: 10px;
  }
`

export const CodeLabel = styled.div`
  background: ${({ selected }: RowProps) => selected ? FACEBOOKBLUE : WHITE};
  color: ${WHITE};
  align-self: flex-end;
  padding: 2px 8px;
  margin-top: 8px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 3px;
  transition: all .25s;
  ${({ secondary, selected }: RowProps) => secondary && `
    color: ${selected ? WHITE : BLUE_BRIGHT};
    border: 1px solid ${selected ? WHITE : BLUE_BRIGHT};
    &:hover {
      cursor: pointer;
      background: ${BLUE_BRIGHT};
      color: ${WHITE};
    }
  `};
`

export const OriginalDiv = styled.div`
  font-size: 11px;
  margin-top: 2px;
  color: ${GRAY_SOFT};
`

export const OpenTabIcon = styled.img`
  width: 9px;
  margin-left: 5px;
  margin-bottom: 3px;
  transition: all .25s;
`

export const AppLabel = styled.div`
  background: ${WHITE};
  align-self: flex-end;
  padding: 2px 8px;
  display: inline-block;
  color: ${BLUE_BRIGHT};
  border: 1px solid ${BLUE_BRIGHT};
  margin-right: 12px;
  vertical-align: bottom;
  font-size: 10px;
  font-style: normal;
  font-weight: bold;
  border-radius: 3px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${BLUE_BRIGHT};
    color: ${WHITE};
    img {
      filter: contrast(0%) brightness(200%);
    }
  }
`

export const Clip = styled(Icon)`
  color: ${RED};
  margin-right: 12px;
`

export const ClipMessage = styled(Icon)`
  color: ${RED};
  margin-right: 8px;
  padding-top: 2px;
`

export const DeleteFile = styled(Icon)`
  color: ${RED};
  margin-left: 10px;
  padding-top: 2px;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

export const FileLabel = styled.div`
  display: flex;
  margin-top: 6px;
  margin-left: 2px;
  font-size: 12px;
  justify-content: ${({ isAdmin }: RowProps) => isAdmin ? 'flex-start' : 'flex-end'};
  &:hover {
    cursor: pointer;
  }
`

export const FileName = styled.div`
  width: ${({ isAdmin }: RowProps) => isAdmin ? 'auto' : '100%'};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${BLUE};
  transition: all .25s;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

export const ParentText = styled.div`
  border-left: 2px solid ${BLUE_SOFT};
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 12px;
  color: ${GRAY_STRONG};
  background: ${GRAY_LIGHTEST};
`

export const RequireDiv = styled.div`
  top: 8px;
  right: 14px;
  position: absolute;
  text-align: right;
  z-index: 2;
  font-size: 12px;
  align-items: center;
  width: 111px;
  display: inline-flex;
  justify-content: space-between;
  background: ${WHITE};
`

export const RequiredText = styled.div`
  font-size: 10px;
  margin-top: 4px;
  margin-right: 4px;
  font-style: italic;
  color: ${GRAY_STRONG};
`

export const SaveButton = styled(Button)`
  border-radius: 2px;
  font-size: 12px;
  height: 26px;
  padding: 0 18px;
  margin-left: 4px;
  background: ${BLUE};
  color: ${WHITE};
  border: none;
`

export const Card = styled.div`
`

export const LeftSide = styled.div`
  display: inline-flex;
  flex-flow: column;
  justify-content: space-between;
  flex: 1;
`

export const FileDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`

export const RenderViewWrapper = styled.div`
  padding: 12px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 1px 6px -1px #a7a7a7;
  animation: fade-in-top 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) 0.2s both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-15px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const RenderView = styled.div`
  height: 529px;
  background-color: white;
  @media (min-width: 1500px) {
    height: 529px;
  }
  @media (min-width: 1740px) {
    height: 600px;
  }
  @media (min-width: 1900px) {
    height: 700px;
  }
  @media (min-width: 2096px) {
    height: 800px;
  }
`

export const CollapseDiv = styled(Collapse)`
  border-radius: 4px;
  border: 1px solid ${GRAY_LIGHT};
  border-bottom: 0;
  box-shadow: 1px 1px 7px -3px #adadad;
  user-select: text;
  .arrow {
    right: 16px !important;
    left: auto !important;
  }
  .ant-collapse-header {
    padding-left: 14px !important;
    font-weight: bold;
    font-family: Avenir-Medium;
    border-bottom: 1px solid ${GRAY_LIGHT};  
  }
  .ant-collapse-content-box {
    cursor: default;
    background: ${({ secondary }: RowProps) => secondary ? WHITE_SMOKE : 'unset'};
  }
  animation: fade-in-top 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) 0.2s both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-15px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const Color = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 1px solid
    ${({ color }: ColorProps) =>
    color && color.toLowerCase() !== WHITE.toLowerCase() ? color : GRAY};
  background-color: ${({ color }: ColorProps) => color || WHITE};
  align-self: center;
`

export const ColorContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-left: 15px;
  margin-bottom: 12px;
`

export const Colors = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 20px 12px;
`

export const CodeColor = styled.div`
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.23px;
  line-height: 25px;
`

export const ColorsWrapper = styled.div`
  display: block;
`

export const InfoLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const InfoLabel = styled.div`
  margin: 16px 0 8px 0;
  font-weight: bold;
  text-transform: capitalize;
`

export const SaveAssetsButton = styled.div`
  padding: 16px 0 8px 0;
  color: ${RED};
  &:hover {
    cursor: pointer;
  }
`

export const ColorName = styled.p`
  margin: 5px 0 0 0;
  font-size: 12px;
  &:hover {
    cursor: text;
  }
`

export const Accesories = styled.div`
  margin: 12px;
`

export const LockerGrid = styled.div`
  margin-top: 13px;
`

export const LockerText = styled.div`
  margin-bottom: 8px;
  font-weight: bold;
  letter-spacing: 0.23px;
  line-height: 25px;
`

export const InspirationImages = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Inspiration = styled.img`
  width: 128px;
  object-fit: cover;
  height: 128px;
  transition: all .25s;
  &:hover {
    filter: brightness(1.1);
    cursor: pointer;
    box-shadow: 0px 2px 7px -1px #9d9d9d;
  }
  &:last-child {
    margin-right: 0;
  }
`

export const InspirationName = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 8px;
  font-size: 12px;
`

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  margin-right: 8px;
`

export const FileBlock = styled.div`
  margin-bottom: 12px;
  max-width: 128px;
  width: 100%;
`

export const DocIcon = styled(Icon)`
  width: 128px;
  height: 128px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 24px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
    box-shadow: 0px 2px 7px -1px #9d9d9d;
  }
  &:last-child {
    margin-right: 0;
  }
`

export const LogoImage = styled.img`
  width: 128px;
  height: 128px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 24px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  padding: 30%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
    box-shadow: 0px 2px 7px -1px #9d9d9d;
  }
  &:last-child {
    margin-right: 0;
  }
`

export const ImageText = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  text-align: center;
  overflow: hidden;
  margin-top: 4px;
  white-space: nowrap;
`

export const CreateTask = styled.div`
  display: inline-block;
  margin-left: 22px;
  border: 1px solid ${RED};
  padding: 0px 12px;
  font-family: Avenir;
  font-size: 11px;
  border-radius: 2px;
  font-weight: normal;
  color: ${RED};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${RED};
    color: ${WHITE};
  }
`

export const TitleLabel = styled.div`
  margin-left: 12px;
  margin-top: 1px;
  display: inline-block;
`

export const CornerIcon = styled(Icon)`
  transform: rotate(90deg);
  width: 7px;
  vertical-align: top;
`

export const PanelItem = styled(Panel)``

export const HeaderTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: grab;
`

export const ContentCard = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 104px;
  height: 100%;
  &:hover {
    cursor: pointer;
  }
`

export const RightSide = styled.div`
  display: inline-flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  max-width: 78px;
  width: 100%;
`

export const Code = styled.div`
  font-size: 12px;
  font-weight: bold;
`

export const Name = styled.div`
  font-size: 16px;
  font-weight: 900;
  font-family: ${AVENIR_MEDIUM};
`

export const ProjectName = styled.div`
  color: ${RED};
`

export const Created = styled.div`
  font-size: 12px;
  &:hover {
    cursor: pointer;
  }
`

export const Status = styled.div`
  width: 100%;
  text-align: center;
  background: ${GRAY_LIGHTEST};
  padding: 4px 7px;
  font-size: 10px;
  text-transform: uppercase;
  overflow-wrap: break-word;
  font-weight: bold;
`

export const PreviewLabel = styled.div`
  width: 100%;
  text-align: center;
  background: ${ORANGE_SELECTED};
  padding: 4px 7px;
  font-size: 10px;
  color: ${ORANGE};
  text-transform: uppercase;
  overflow-wrap: break-word;
  font-weight: bold;
`

export const ApprovedLabel = styled.div`
  width: 100%;
  text-align: center;
  background: ${GREEN_SELECTED};
  padding: 4px 7px;
  font-size: 10px;
  color: ${GREEN};
  text-transform: uppercase;
  overflow-wrap: break-word;
  font-weight: bold;
`

export const Thumbnail = styled.img`
  object-fit: contain;
  width: 100%;
  background: ${GRAY_LIGHTEST};
`

export const Buttons = styled.div`
  display: inline-flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  z-index: 2;
`

export const EditModel = styled(Button)`
  padding: 9px 28px;
  color: white;
  height: auto;
  background-color: ${BLUE};
  margin-top: 8px;
`

export const DetailsContainer = styled.div`
  display: inline-flex;
  width: 100%;
  margin-top: 22px;
  flex-flow: column;
`
export const FormBody = styled.div`
  .ant-card-body {
    padding: 16px;
  }
`

export const HeaderRow = styled.div`
  padding-bottom: 40px;
  margin-top: 24px;
  margin-bottom: 20px;
  display: flex;
  border-bottom: 1px solid #dcdcdc;
  justify-content: space-between;
  align-items: flex-start;
`
export const Row = styled.div`
  margin: ${({ margin }: RowProps) => (margin ? margin : '16px 0')};
  border-bottom: ${({ borderBottom }: RowProps) =>
    borderBottom ? borderBottom : 'unset'};
  padding-bottom: ${({ paddingBottom }: RowProps) =>
    paddingBottom ? paddingBottom : 'unset'};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`
export const Separator = styled.div`
  border-bottom: 1px solid #dcdcdc;
  color: #5f6062;
  font-family: 'Avenir Next';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  padding-bottom: 10px;
  margin-bottom: 30px;
  margin-top: 84px;
`
export const RowImage = styled.img`
  max-height: 200px;
  object-fit: cover;
`

export const RenderBackground = styled.div`
  background: ${({ openedModel }: any) => (openedModel ? '#f3f3f3' : 'white')};
  transition: all 0.25 ease;
  text-align: center;
`

export const ModelSection = styled.div`
  position: relative;
`

export const RowLink = styled.a`
  color: ${BLUE};
  text-decoration: underline;
  flex: 2;
  text-align: left;
  padding-top: unset;
  margin-right: 16px;
`

export const columnStyle = {
  background: GRAY_HEADER
}

export const columnHeaderStyle = {
  background: GRAY_HEADER,
  padding: '0 4px',
  marginBottom: '-8px'
}

export const columnTitleStyle = {
  fontWeight: 'bold',
  fontFamily: AVENIR_MEDIUM
}

export const FileContainer = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  margin-right: 13px;
  margin-bottom: 4px;
`

export const ActionsIcons = styled.div`
  display: flex;
  margin-top: 18px;
  margin-bottom: -37px;
`

export const LikeAction = styled.div`
  margin-right: 14px;
  font-size: 12px;
  display: flex;
`

export const HeartAction = styled.div`
  margin-right: 12px;
  font-size: 12px;
  display: flex;
`

export const LikeIcon = styled(Icon)`
  margin-right: 8px;
  font-size: 14px;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const HeartIcon = styled(Icon)`
  margin-right: 8px;
  font-size: 14px;
  color: ${RED_TRANSPARENT};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ReplyComment = styled.div`
  text-align: right;
  margin-top: 6px;
  padding-right: 6px;
  font-size: 12px;
  color: ${BLUE};
  font-style: italic;
  font-family: Avenir-Medium;
  font-weight: 500;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ReplyIcon = styled(Icon)`
  margin-left: 6px;
`

export const FullResponse = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const CommentHeader = styled.div`
  margin-left: 2px;
  font-size: 14px;
  font-weight: bold;
  font-family: Avenir;
  margin-bottom: 4px;
  text-align: left;
  color: ${({ codeColor }: RowProps) => codeColor || BLUE};
  filter: contrast(0.5);
`

export const RemoveParent = styled(Icon)`
  font-size: 12px;
  margin-left: 11px;
  flex: 1;
  text-align: left;
  margin-bottom: 4px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ParentTextCode = styled.div`
  border-left: 2px solid ${({ codeColor }: RowProps) => codeColor || RED_TRANSPARENT};
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 12px;
  color: ${GRAY_STRONG};
  background: ${WHITE};
  text-align: left;
`

export const StyledUploadPrint = styled(Upload)`
  margin-left: 20px;
  .ant-upload-select-picture-card {
    border: 1px solid ${BLUE};
    width: 95px;
    height: 22px;
    background: ${WHITE};
    border-radius: 3px;
    margin-bottom: 0;
    transition: all .25s;
    @media (max-width: 767px) {
      width: 100%;
    }
    &:hover {
      background: ${BLUE};
      border: 1px solid ${BLUE};
      cursor: pointer;
      span > div {
        color: ${WHITE} !important;
      }
    }
    span {
      padding: 0 6px !important;
    }
  }
`

export const UploadButtonPrint = styled.div`
  color: ${BLUE};
  display: flex;
  word-spacing: 5px;
  align-items: center;
  font-size: 12px;
  justify-content: center;
  transition: all .25s;
  width: 100%;
  .ant-spin {
    padding-top: 3px;
  }
`

export const StartButton = styled.div`
  position: absolute;
  right: 52px;
  border: 1px solid #7dcf50;
  background: #7dcf50;
  max-width: 68px;
  font-size: 12px;
  border-radius: 3px;
  color: white;
  width: 100%;
  text-align: center;
  font-family: Avenir;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  box-shadow: 1px 1px 2px -1px #939393;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${WHITE};
    color: #7dcf50;
  }
  .ant-spin {
    margin-top: 5px;
  }
`

export const StopButton = styled.div`
  position: absolute;
  right: 52px;
  border: 1px solid #b2b2b2;
  background: #b2b2b2;
  max-width: 68px;
  font-size: 12px;
  border-radius: 3px;
  color: white;
  width: 100%;
  text-align: center;
  font-family: Avenir;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  box-shadow: 1px 1px 2px -1px #939393;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${WHITE};
    color: #b2b2b2;
  }
  .ant-spin {
    margin-top: 5px;
  }
`

export const PrintFilesDiv = styled.div`
  display: flex;
  flex-flow: column;
  overflow-y: scroll;
  background: ${WHITE_SMOKE};
  padding: 0 17px;
  height: 100%;
  @media (max-width: 698px) {
    padding: 0 6px;
  }
`

export const PrintFile = styled.div`
  display: flex;
  background: white;
  margin-top: 12px;
  border-radius: 4px;
  margin-bottom: 18px;
  box-shadow: 0px 2px 4px -1px #d5d5d5;
  position: relative;
  z-index: 2;
`

export const ImageSection = styled.div`
  position: relative;
`

export const PrintImage = styled.img`
  max-width: 168px;
  max-height: 158px;
  width: 100%;
  object-fit: cover;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  transition: all .25s;
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
`

export const ActionButtons = styled.div`
  position: absolute;
  right: 3px;
  bottom: 3px;
  background: #00000030;
  padding: 1px 10px;
  border-radius: 25px;
`

export const WatchIcon = styled(Icon)`
  color: white;
  margin-right: 10px;
  font-size: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const DownloadIcon = styled(Icon)`
  color: white;
  font-size: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const InfoSection = styled.div`
  margin-left: 15px;
  margin-top: 8px;
  font-size: 14px;
  font-family: Avenir;
  text-align: left;
`

export const CodeValue = styled.div`
  font-weight: bold;
  font-family: Avenir;
`

export const ApprovedCornerLabel = styled.div`
  position: absolute;
  right: 12px;
  top: 8px;
  font-size: 10px;
  font-weight: normal;
  padding: 2px 8px;
  padding-bottom: 1px;
  font-family: Avenir;
  border-radius: 25px;
  color: ${WHITE};
  background: ${COLOR_AM_REVIEW};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
`

export const UploadedValue = styled.div`
  font-size: 12px;
  margin-top: 4px;
  display: flex;
`

export const DateValue = styled.div`
  margin-left: 4px;
`

export const ActivatedBy = styled.div`
  font-size: 12px;
  margin-top: 10px;
  display: flex;
  color: ${COLOR_AM_REVIEW};
  flex-flow: column;
`

export const VisibleBy = styled.div`
  font-size: 12px;
  margin-top: 2px;
  display: flex;
  color: ${BLUE};
`

export const ApprovedBy = styled.div`
  font-size: 12px;
  margin-top: 2px;
  display: flex;
  flex-flow: column;
  color: ${COLOR_AM_REVIEW};
`

export const RejectedBy = styled.div`
  font-size: 12px;
  margin-top: 10px;
  display: flex;
  color: ${RED};
  flex-flow: column;
`

export const ActivatorValue = styled.div``

export const LabelValue = styled.div`
  font-weight: 500;
  display: inline;
`

export const ActivationDate = styled.div`
  font-size: 11px;
  margin-top: 1px;
  margin-bottom: -5px;
`

export const StyledSwitch = styled(Switch)`
  align-self: center;
  position: absolute;
  right: 18px;
`

export const TicketLink = styled.a`
  display: inline;
  margin-left: 2px;
  padding-left: 10px;
  font-weight: normal;
  color: ${BLUE};
  font-size: 12px;
`

export const ButtonsDiv = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
`

export const RejectButton = styled.div`
  font-size: 11px;
  border-radius: 25px;
  border: 1px solid ${RED};
  padding: 1px 10px;
  padding-top: 2px;
  background: ${RED};
  color: ${WHITE};
  transition: all .25s;
  margin-right: 8px;
  opacity: 0.7;
  &:hover {
    cursor: pointer;
    background: ${WHITE};
    color: ${RED};
  }
`

export const RejectIcon = styled(Icon)`
  margin-right: 4px;
  margin-left: -2px;
`

export const ApproveButton = styled.div`
  font-size: 11px;
  border-radius: 25px;
  border: 1px solid ${BLUE};
  padding: 1px 10px;
  padding-top: 2px;
  background: ${BLUE};
  color: ${WHITE};
  transition: all .25s;
  opacity: 0.9;
  &:hover {
    cursor: pointer;
    background: ${WHITE};
    color: ${BLUE};
  }
`

export const ApproveIcon = styled(Icon)`
  margin-right: 4px;
  margin-left: -2px;
`

export const StyledSpin = styled(Spin)`
  margin-right: 5px;
  margin-top: -12px;
  margin-bottom: -15px;
  margin-left: -4px;
  filter: brightness(7);
`

export const EmptyMessage = styled.div`
  font-size: 13px;
  background: ${WHITE};
  padding: 10px 30px;
  margin-top: 16px;
  font-family: Avenir;
  border-radius: 5px;
  color: ${GRAY_DARK};
`

export const MainBody = styled.div``

export const RejectNote = styled.div`
  background: ${WHITE};
  max-width: 95%;
  margin: 0 auto;
  margin-top: -24px;
  padding: 9px;
  padding-top: 12px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  border: 1px solid #fdabab;
  font-size: 11px;
  text-align: left;
  margin-bottom: 12px;
  z-index: 1;
  animation: fade-in-top 0.35s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const RejectTitle = styled.div`
  font-weight: bold;
  font-family: Avenir;
  color: ${RED};
  text-align: left;
`

export const RejectedIcon = styled(Icon)`
  margin-right: 6px;
`

export const RejectedDescription = styled.div``



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignApproval/TestPrints/styledComponents.tsx